import { render, staticRenderFns } from "./FinalDecisionCard.vue?vue&type=template&id=3057905e"
import script from "./FinalDecisionCard.vue?vue&type=script&lang=js"
export * from "./FinalDecisionCard.vue?vue&type=script&lang=js"
import style0 from "./FinalDecisionCard.vue?vue&type=style&index=0&id=3057905e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports